import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from "ngx-alerts";
import { NgxSpinnerService } from "ngx-spinner";
import { LOCAL_STORAGE, StorageService } from "ngx-webstorage-service";
import { finalize } from "rxjs/operators";
import { DashboardService } from "src/app/services/dashboard.service";

@Component({
  selector: "app-all-vehicles",
  templateUrl: "./all-vehicles.component.html",
  styleUrls: ["./all-vehicles.component.scss"],
})
export class AllVehiclesComponent implements OnInit {
  vehicles = [];
  loggedInUser: any;
  channelId: any = "";
  driverVehiclesSearch = {
    channelId: "",
    page: 0,
    size: 999,
    search: "",
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private alertService: AlertService,
    public dashboardService: DashboardService,
    private spinner: NgxSpinnerService
  ) {
    this.loggedInUser = storage.get("gs-loggedInUser");

    this.channelId = this.loggedInUser.channelId;
    this.driverVehiclesSearch.channelId = this.channelId;
  }

  ngOnInit(): void {
    this.getAllVehicles();
  }

  getAllVehicles() {
    this.dashboardService
      .getAllDriversVehicles(this.driverVehiclesSearch)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.vehicles = res.userVehicles;
        },
        (error) => {
          console.error(error);
          this.alertService.danger(error.message ? error.message : error);
        }
      );
  }
}
